import type { z } from 'zod';

import { taxIdentificationNumberFormatsQueryOptions } from '@/hooks/queries/use-tax-identification-number-formats';
import i18n from '@/lib/i18n';
import { queryClient } from '@/lib/query-client';

type TaxIdentificationNumberRefinement = {
  country: string;
  taxId: string;
};

export const taxIdentificationNumberRefinement = async ({ country, taxId }: TaxIdentificationNumberRefinement, context: z.RefinementCtx) => {
  if (!country) return;

  const { examples, validate } = await queryClient.ensureQueryData(taxIdentificationNumberFormatsQueryOptions);
  const { accepted, outcome } = validate(country, taxId);

  if (accepted) return;

  context.addIssue({
    code: 'custom',
    message:
      outcome === 'MISSING'
        ? i18n.t('personalInformation.errors.taxIdentificationNumber')
        : i18n.t('personalInformation.errors.taxIdentificationNumberInvalid', { example: examples[country] ?? '' }),
    path: ['taxId'],
  });
};
